import dashboard from "./dashboard"
import detailsGeneric from "./detailsGeneric"
import managementChannels from "./managementChannels"
import managementIntegrations from "./managementIntegrations"

export default {

...dashboard,
...detailsGeneric,
...managementChannels,
...managementIntegrations







}